<script lang="ts">
    import type {SearchManager} from '../search-manager/search-manager';
    import {setSearchContext, getSearchContextConnector} from './search-context';
    import {exists} from 'shared/utils/custom-utils';

    export let searchManager: SearchManager<any> | null = null;

    setSearchContext(searchManager);

    const searchContextConnector = getSearchContextConnector();
    if (exists(searchContextConnector)) {
        searchContextConnector.set(searchManager);
    }
</script>

<slot {searchManager}/>